import ReactDOMServer from "react-dom/server";
import classNames from "classnames";

import IconElement from "../Utils/Icon";

const Icon = props => {
  const { iconClass, width, height, color, anchorTop, anchorLeft, position, content } =
    props;

  if (!iconClass) return "";

  const className = classNames(
    "text-shadow-lg",
    "map-element-image",
    "map-element-icon",
    props.className,
    iconClass
  );

  // We use the width property to set the font-size to ensure that the size of icon fonts 
  // is proportional to the user-specified width. This helps maintain visual consistency, 
  // as users primarily specify the icon width. Additionally, the fontSize property 
  // influences the overall size of the icon. Container dimensions are also set using 
  // width and height to ensure correct rendering of icons.
  return ReactDOMServer.renderToString(
    <IconElement
      className={className}
      style={{
        position: position || "absolute",
        top: anchorTop || 0,
        left: anchorLeft || 0,
        color,
        fontSize: height || width,
        width: width,
        height: height
      }}
    >
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </IconElement>
  );
};

const Image = props => {
  const { image, width, height, anchorTop, anchorLeft, position, content } = props;

  const { url } = image;
  const className = classNames("map-element-image", props.className);

  return ReactDOMServer.renderToString(
    <div
      className={className}
      style={{
        position: position || "absolute",
        top: anchorTop || 0,
        left: anchorLeft || 0,
        width: width,
        height: height,
        backgroundImage: `url(${url})`,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundColor: "transparent"
      }}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

const MapElementImage = style => {
  return style.image ? Image(style) : Icon(style);
};

export default MapElementImage;
